import React from 'react'
import { GoArrowUpRight } from 'react-icons/go'

const Services = () => {
    const services = [
        {
            id: 1,
            name: "Website Design & Redesign",
            desc: "Popular Services",
        },
        {
            id: 2,
            name: "Website Development",
            desc: "Popular Services",
        },
        {
            id: 3,
            name: "Website Management",
            desc: "Popular Services",
        },
        {
            id: 4,
            name: "Thumbnail Design",
            desc: "Popular Services",
        },
    ]
    return (
        <div className="gradul md:py-16 py-8" id='services'>
            <div className='max-w-[1000px] md:mx-auto mx-4'>
                <div className="text-center"><span className="bg-[#0788ff33] p-2 uppercase rounded-lg">SERVICES</span></div>

                <h2 className="md:text-4xl text-3xl font-bold mb-8 mt-3 uppercase text-center">My <span className='text-secondary'>special services</span> for your <br /> business development</h2>
                <div className="grid md:grid-cols-2 md:gap-16 gap-8">
                    {services.map((i, index) => {
                        return (
                            <div className="p-6 rounded-xl grad shadow-lg cursor-pointer shadow-secondary/70 border border-transparent hover:border-secondary hover:-translate-y-2 duration-300 md:flex justify-between" key={index}>
                                <div className='text-xl font-semibold'>0{i.id}.</div>
                                <div className='md:mt-0 mt-3'>
                                    <h3 className='text-xl font-semibold'>{i.name}</h3>
                                    <p className='text-darklight'>{i.desc}</p>
                                </div>
                                <div className='bg-secondary rounded-full p-4 text-2xl md:mt-0 mt-2 inline-block '><GoArrowUpRight /></div>
                            </div>
                        )
                    })}
                </div>
            </div>
        </div>
    )
}

export default Services
